export const actions = {
  EVENT_TRIGGERED_MODAL_OPEN: 'EVENT_TRIGGERED_MODAL_OPEN',
  EVENT_TRIGGERED_MODAL_CLOSE: 'EVENT_TRIGGERED_MODAL_CLOSE',
};

export function openEventTriggeredModal(name, options = {}, props = {}) {
  return {
    type: actions.EVENT_TRIGGERED_MODAL_OPEN,
    payload: {
      name,
      options,
      props,
    },
  };
}

export function closeEventTriggeredModal() {
  return {
    type: actions.EVENT_TRIGGERED_MODAL_CLOSE,
  };
}
